import BookingsView from './BookingsView';

export default BookingsView;
